import { ReactComponent as CalendarIcon } from "assets/icons/calendar.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import {
    Button,
    DatePicker,
    TimeSubscription,
    useAccessToken,
    useOutsideClick,
} from "modules/common";
import { updateEducationTimeSubscription } from "modules/dashboard";
import React, { useEffect, useRef, useState } from "react";
import { DayModifiers } from "react-day-picker";
import { useDispatch } from "react-redux";
import { getEducationTimeSubscription } from "services";

const EducationTimeSubscription: React.FC = () => {
    const dispatch = useDispatch();
    const accessToken = useAccessToken();
    const [isOpen, setIsOpen] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [isEnabled, setIsEnabled] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const fetchEducationTime = async () => {
            const result = await getEducationTimeSubscription(accessToken ?? "");
            if (result) {
                setStartDate(result.startDate ? new Date(result.startDate) : null);
                setEndDate(result.endDate ? new Date(result.endDate) : null);
                setIsEnabled(result.isEnabled ?? false);
            }
        };

        fetchEducationTime();
    }, [accessToken]);

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("click", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [isOpen]);

    const handleStartDateClick = (
        day: Date | null,
        _modifiers: DayModifiers,
        _e?: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        setStartDate(day);
    };

    const handleEndDateClick = (
        day: Date | null,
        _modifiers: DayModifiers,
        _e?: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        setEndDate(day);
    };

    const handleSubmit = async () => {
        const timeSubscription: TimeSubscription = {
            startDate,
            endDate,
            isEnabled,
        };

        await dispatch(updateEducationTimeSubscription(timeSubscription));
        setIsOpen(false);
    };

    return (
        <div className="education-time-subscription-container">
            <Button
                isIcon
                variant={isEnabled ? "primary" : "primary-ghost"}
                onClick={() => setIsOpen(!isOpen)}
                size={"small"}
            >
                <CalendarIcon />
            </Button>

            {isOpen && (
                <div className="education-time-menu" ref={menuRef}>
                    <div className="education-menu-header">
                        <span className="education-title">
                            Vremenski okvir predbilježbe na tečajeve
                        </span>
                        <button className="education-close-button" onClick={() => setIsOpen(false)}>
                            <CloseIcon className="education-close-icon" />
                        </button>
                    </div>
                    <hr />

                    <div className="education-content">
                        <div className="education-date-container">
                            <div className="education-date-item">
                                <label>Datum od:</label>
                                <DatePicker
                                    onClick={handleStartDateClick}
                                    selectedDay={startDate}
                                    value={startDate ?? new Date()}
                                    isValid={true}
                                    minDate={new Date()}
                                />
                            </div>
                            <div className="education-date-item">
                                <label>Datum do:</label>
                                <DatePicker
                                    onClick={handleEndDateClick}
                                    selectedDay={endDate}
                                    value={
                                        endDate ??
                                        new Date(new Date().setMonth(new Date().getMonth() + 3))
                                    }
                                    isValid={true}
                                    displayMonth={startDate ?? new Date()}
                                />
                            </div>
                        </div>

                        <div className="education-subscription-item">
                            <span className="education-prompt-text">Predbilježbe aktivirane: </span>
                            <input
                                type="checkbox"
                                checked={isEnabled}
                                onChange={e => setIsEnabled(e.target.checked)}
                            />
                        </div>

                        <div className="education-button-container">
                            <button className="education-submit-button" onClick={handleSubmit}>
                                Spremi
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EducationTimeSubscription;
